import { apiConstatnts } from "constants/apiConstants";
import httpRequset from "utils/HttpRequest";

const { REACT_APP_API_URL } = process.env;

async function getOrganizationPoint() {
  try {
    const url = `${REACT_APP_API_URL}/point`;

    return httpRequset(apiConstatnts.GET, apiConstatnts.DISABLE_AUTHORIZATION, apiConstatnts.contentType.JSON, url, null);
  } catch (error) {
    throw error;
  }
}

export const promotionService = {
  getOrganizationPoint,
};
